<template>
    <div>
        <div v-if="!hasLogin" class="loginForm">
            <h1>后台管理</h1>
            <a-form-model :model="form" :rules="rules" ref="loginForm">
                <a-form-model-item prop="username" label="账号">
                    <a-input v-model="form.username"></a-input>
                </a-form-model-item>
                <a-form-model-item prop="password" label="密码">
                    <a-input v-model="form.password" type="password"></a-input>
                </a-form-model-item>
            </a-form-model>
            <a-button type="primary" :loading="isLogining" block
                @click="handleLogin"
            >登录</a-button>
        </div>
        <div v-else>
            <a-result
                status="error"
                title="访问被拒绝"
            >
                <template #extra>
                    <!-- <a-button key="logout">
                        退出账号
                    </a-button> -->
                </template>

                <div class="desc">
                <p style="font-size: 16px;">
                    <strong>此账号没有管理员权限</strong>
                </p>
                </div>
            </a-result>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    data: () => ({
        form: {
            username: "",
            password: ""
        },
        isLogining: false,
        rules: {
            username: [
                { required: true, message: '请输入用户名' }
            ],
            password: [
                { required: true, message: '请输入密码' }
            ],
        }
    }),
    computed: {
        ...mapState([ "hasLogin" ]),
        ...mapState("$privilege", [ "notAdmin" ]),
    },
    methods: {
        ...mapActions([ "doLogin" ]),
        ...mapActions("$privilege", [ "fetch" ]),
        async handleLogin() {
            this.isLogining = true;
            await this.doLogin(this.form);
            if (this.hasLogin) {
                await this.fetch();
                this.isLogining = false;
                if (!this.notAdmin) {
                    this.$router.push({ name: 'home' });
                }
            }
            this.isLogining = false;
        }
    }
}
</script>

<style lang="less">
.loginForm {
    width: 300px;
    padding: 40px;
    margin: auto;
    margin-top: 60px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}
</style>